module.exports = __webpack_public_path__ + "static/media/cp-verma.70027235.png";